/**
 * A creative made from the designer's designs, as a preview draws it: the engine's design frame (site/js/admarket.js
 * directAdHtml, kind "design") pointed at the design's own preview (worker/src/addesign.js previewResponse: the
 * advertiser's at /api/market/designs, staff's at /api/dashboard/ads/designs). The slot's size picks the design, as the
 * engine does (that size, else the next smaller leaderboard size).
 */
const LEADERBOARD = ["728x90", "468x60", "320x50"];
export function designPreview<T extends { designs?: Record<string, { id: string }>; kind?: string; frame?: string }>(cr: T, unit: string, base = "/api/market/designs"): T {
  const ds = cr.designs || {};
  let id = ds[unit]?.id;
  if (!id && LEADERBOARD.includes(unit)) for (const s of LEADERBOARD.slice(LEADERBOARD.indexOf(unit) + 1)) if (ds[s]?.id) { id = ds[s].id; break; }
  return id ? { ...cr, kind: "design", frame: `${base}/${id}/preview?variant=default` } : cr;
}
